var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrderSelectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 27 27",
    style: {
      enableBackground: "new 0 0 27 27"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F05123;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.9,26.2c2.5,0,4.6-2,4.6-4.6V5.2c0-2.5-2-4.6-4.6-4.6H7.1c-2.5,0-4.6,2-4.6,4.6v16.4c0,2.5,2,4.6,4.6,4.6 C7.1,26.2,19.9,26.2,19.9,26.2z M4.4,5.2c0-1.5,1.2-2.7,2.7-2.7h12.8c1.5,0,2.7,1.2,2.7,2.7v16.4c0,1.5-1.2,2.7-2.7,2.7H7.1 c-1.5,0-2.7-1.2-2.7-2.7C4.4,21.6,4.4,5.2,4.4,5.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.7,14.3H19c0.5,0,0.9-0.4,0.9-0.9s-0.4-0.9-0.9-0.9h-7.3c-0.5,0-0.9,0.4-0.9,0.9S11.2,14.3,11.7,14.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.7,9.8H19c0.5,0,0.9-0.4,0.9-0.9S19.5,8,19,8h-7.3c-0.5,0-0.9,0.4-0.9,0.9C10.8,9.4,11.2,9.8,11.7,9.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.7,18.9H19c0.5,0,0.9-0.4,0.9-0.9s-0.4-0.9-0.9-0.9h-7.3c-0.5,0-0.9,0.4-0.9,0.9S11.2,18.9,11.7,18.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.1,9.8C8.6,9.8,9,9.4,9,8.9S8.6,8,8.1,8l0,0C7.6,8,7.2,8.4,7.2,8.9C7.2,9.4,7.6,9.8,8.1,9.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.1,14.3c0.5,0,0.9-0.4,0.9-0.9s-0.4-0.9-0.9-0.9l0,0c-0.5,0-0.9,0.4-0.9,0.9S7.6,14.3,8.1,14.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.1,18.9C8.6,18.9,9,18.5,9,18s-0.4-0.9-0.9-0.9l0,0c-0.5,0-0.9,0.4-0.9,0.9S7.6,18.9,8.1,18.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderSelectIcon);
export default __webpack_public_path__ + "static/media/orderSelectIcon.919b4da31547914dd49dc777c6741b57.svg";
export { ForwardRef as ReactComponent };